import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/planning")({
  staticData: {
    // Planning is managed under Feuilles de Temps permissions
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW,
  },
  component: () => <Outlet />,
});
